export enum TostTypeEnum {
    SUCCESS = 1, ERROR = 2,LOAD
}

export enum TostPositionEnum {
    TopRight = 1, TopLeft = 2, BottomRight = 3, BottomLeft = 4
}

export interface Tost {
    guid:string,
    message: {he:string,en:string},
    type: TostTypeEnum,
    seconds?: number,
    position?: TostPositionEnum,
    zIndex?:number,
}